import { Cell } from '../../../../components/common/table/Cell/Cell';
import { Row } from '../../../../components/common/table/Row/Row';
import './MessageListRow.scss';
import { format } from 'date-fns';
import '../MessageList.scss';

export interface MessageListRowProps {
  timestamp: string;
  message: string;
  tag: string;
  level: string;
  index: number;
}

export function MessageListRow({ timestamp, message, tag, level, index }: MessageListRowProps) {
  return (
    <Row index={index} classes="row-container">
      <Cell>{format(new Date(timestamp), 'yyyy-MM-dd HH:MM:SS')}</Cell>
      <Cell>{level}</Cell>
      <Cell capitalized>{tag}</Cell>
      <Cell>{message}</Cell>
    </Row>
  );
}
